<!--
  --
  -- ログインしていないときのアクションコンポーネント
  --
  -->
<template>
  <div class="d-flex">
    <!-- モバイル用ボタン -->
    <template v-if="$vuetify.breakpoint.xsOnly">
      <v-btn icon color="primary" @click="onRegister">
        <v-icon>person_add</v-icon>
      </v-btn>
      <v-btn icon color="primary" :to="{name: 'login'}">
        <v-icon>lock_open</v-icon>
      </v-btn>
    </template>

    <!-- タブレット & PC 用ボタン -->
    <template v-else>
      <v-btn class="ml-4" color="primary" @click="onRegister">会員登録はこちら</v-btn>
      <v-btn class="ml-4" outlined :to="{name: 'login'}">ログイン</v-btn>
    </template>
  </div>
</template>

<script>
import { run } from '@/libs/a'

export default {
  name: 'CLoginNav',
  methods: {
    onRegister () {
      run(() => {
        this.commit('register/init')
        this.goTo({ name: 'register' })
      })
    }
  }
}
</script>
